export const TableName = {
    form_item: "form_item",
    payment_term: "payment_term",
    payment_deposit_item: "payment_deposit_item",

    bank_item: "bank_item",
    journal_item: "journal_item",

    product_unit: "product_unit",
    stock_adjustment: "stock_adjustment",
    stock_transfer: "stock_transfer",
    stock_values: "stock_values",

    batch_asset: 'batch_asset',
    batch_invoice: 'batch_invoice',
    batch_invoice_cash: 'batch_invoice_cash',
    batch_quotation: 'batch_quotation',
    batch_invoice_credit_note: 'batch_invoice_credit_note',
    batch_invoice_payment: 'batch_invoice_payment',
    batch_sale_order: 'batch_sale_order',
    batch_purchase_order: 'batch_purchase_order',
    batch_bill: 'batch_bill',
    batch_bill_cash: 'batch_cash_bill',
    batch_bill_expense_claim: 'batch_bill_expense_claim',
    batch_bill_payment: 'batch_bill_payment',
    batch_bank_income: 'batch_bank_income',
    batch_bank_expense: 'batch_bank_expense',
    batch_journal_entry: 'batch_journal_entry',

    opening_balance: "opening_balance",
    opening_invoice: "opening_invoice",
    opening_bill: "opening_bill",

    custom_field_dropdown_option: 'custom_field_dropdown_option',

    product_sale_prices: 'product_sale_prices',
    product_purchase_prices: 'product_purchase_prices',
    product_bundle: 'product_bundle',
};
